import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { TranslateModule } from '@ngx-translate/core';
import { ModularSurveyComponent } from '../modular-survey/components';
import { ModularSurvey } from '../modular-survey/services';
import { RestService } from 'src/app/services';

@Component({
  selector: 'app-incidents-reporter-button',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './incidents-reporter-button.component.html',
  styleUrls: ['./incidents-reporter-button.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IncidentsReporterButtonComponent {  
  private _restService = inject(RestService); // TODO: CAMBIAR PARA SSR AL SERVICIO SUBDOMAIN
  private _modularSurveyService = inject(ModularSurvey);
  private _matBottomSheet = inject(MatBottomSheet);

  public openBottomSheet(): void {
     this._matBottomSheet.open(ModularSurveyComponent, {
        panelClass: 'modular-survey-bottom-sheet'
     });
  }

  protected prefetchSurveyData(): void {
    const subdomain = this._restService.subDomain;
    if (!subdomain) return;

    this._modularSurveyService.setSurveyDataServiceSignal(subdomain);
  }
  
}
